import React from 'react';

import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';

import theme from '../../muiTheme';
import './RequiredFieldStatus.css';

const RequiredFieldStatus = (props) => {

const missingFieldsMessage = "Required Fields Missing";

  return (
    <Chip
      className="required-field-status-chip"
      onClick={props.chipClicked}
      backgroundColor="#ECEFF5"
      labelStyle={{lineHeight: "21px"}}>
      <Avatar style={{fontSize: "12px", width: "22px", height: "22px"}} backgroundColor={theme.palette.accent1Color}>{props.missingFields}</Avatar>
        <span style={{fontSize: "12px"}}>{missingFieldsMessage}</span>
    </Chip>
  );
}

export default RequiredFieldStatus;
